import { PublicCallback } from 'globals/types';
import { importAndInitializePubNub } from 'core_main/helpers/vendors';
import { getStore } from 'core_main/store';
import { createSession } from 'core_main/api/sessions';
import { ON_CONVERSATION_CREATE_EVENT_TYPE } from 'core/constants';
import { runListenersForEvent } from 'core_main/helpers/events';
import { createConversationCallbackResponse } from './helpers';
import { CreateConversationParameters } from './types';

export const createConversation = (
  parameters: CreateConversationParameters,
  cb?: PublicCallback,
) => {
  return createSession(parameters)
    .then((response) => {
      const customerId = response.data.relationships.customer.data.id;

      const { channels } = response.data.attributes.pubnub.data;

      const sharedConversationChannel = channels.find(
        (channel) => channel.type === 'shared-conversation',
      );

      const sharedConversationChannelName = sharedConversationChannel?.name;

      const { orgId } = getStore();

      return importAndInitializePubNub({
        customerId,
        orgId,
        channels: sharedConversationChannelName
          ? [sharedConversationChannelName]
          : undefined,
        initCallback: () => {
          const callbackResponse = createConversationCallbackResponse(response);

          runListenersForEvent(
            ON_CONVERSATION_CREATE_EVENT_TYPE,
            callbackResponse,
          );

          if (typeof cb === 'function') {
            cb(callbackResponse);
          }
        },
      });
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      runListenersForEvent(ON_CONVERSATION_CREATE_EVENT_TYPE, null, error);
      console.error('Failed to create conversation:', error);
    });
};
